module.exports = __webpack_public_path__ + "static/Q10Answer_imfourteen_wishmastree-259b4c90833639fdfb949fbe4b75f7b2.jpg";